import * as contentfulClient from 'app/api/contentful-client';
import * as actions from 'app/store/actions/glowforge-store';

export const fetchProducts = () => ({
  promise: async http => (http.get('/base://storefront/api/search')),
  events: ['PROMISE_PENDING', actions.SET_GLOWFORGE_PRODUCT_LIST, 'PROMISE_ERROR'],
});

export const fetchOrderDetails = (orderNumber, key) => ({
  promise: async http => (http.get(`/base://storefront/api/orders/details?number=${orderNumber}&key=${key}`)),
  events: ['PROMISE_PENDING', actions.SET_ORDER_DETAILS, 'PROMISE_ERROR'],
});

export const fetchConfirmationPage = () => ({
  promise: () => contentfulClient.getPage('glowforge-confirmation-page'),
  events: ['PROMISE_PENDING', actions.SET_CONFIRMATION_PAGE, 'PROMISE_ERROR'],
});



// WEBPACK FOOTER //
// ./app/store/api/glowforge-store-api.js